import definition from './geo.service';

/**
 * GeoService settings
 * @type {{name: string, definition: GeoService}}
 */
const Service = {
    name: 'GeoService',
    definition
};

export {
    Service
};



// WEBPACK FOOTER //
// ./app/services/geo/index.js